// A polyfilled environment for React 16 using core-js to support older browsers
import 'core-js/stable/map';
import 'core-js/stable/set';
import 'core-js/stable/array/includes';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import Loadable from 'react-loadable';
import store from './store';
import App from './App';

import './stylesheets/footer/Footer.less';
import './stylesheets/zola-icon-fonts.less';

const TertiaryRegistryNav = Loadable({
  loader: () => import('./components/nav/TertiaryNav/TertiaryRegistryNav'),
  loading: () => <div />, // Intentional. No spinning wheel when loading tertiary nav
});

const AddItemDrawer = Loadable({
  loader: () => import('./components/registry/AddItemDrawer/AddItemDrawer'),
  loading: () => <div />, // Intentional. Spinning wheel for this component causing page jump when loading
});

const FooterV3 = Loadable({
  loader: () => import('@zola/zola-ui/src/components/PreAuthV3/PreauthFooterV3'),
  loading: () => <div />,
});

const BabyFooter = Loadable({
  loader: () => import('@zola/zola-ui/src/components/footers/baby/BabyFooter'),
  loading: () => <div />,
});

const root = document.getElementById('root-nav');

render(
  <Provider store={store}>
    <App />
  </Provider>,
  root
);

// Inject the tertiary nav into its root container
function launchtertiary() {
  const tertiaryRoot = document.getElementById('tertiary-nav-root');
  if (tertiaryRoot) {
    render(
      <Provider store={store}>
        <TertiaryRegistryNav />
      </Provider>,
      tertiaryRoot
    );
  }
}

// Inject the shared footer into its root container
function injectWebsiteFooter() {
  const isBaby = window.location.hostname.toLowerCase().indexOf('baby.zola.com') > -1;
  const websiteFooter = document.getElementById('website-footer');
  if (websiteFooter) {
    render(
      <Provider store={store}>{isBaby ? <BabyFooter /> : <FooterV3 isGuest={false} />}</Provider>,
      websiteFooter
    );
  }
}

// Inject the add item drawer on shop pages (web-zola)
function injectAddItemDrawer() {
  const addItemDrawer = document.getElementById('add-item-drawer');
  if (addItemDrawer && addItemDrawer.childNodes.length === 0) {
    render(
      <Provider store={store}>
        <AddItemDrawer />
      </Provider>,
      addItemDrawer
    );
  }
}

// Inject the tertiary nav
document.addEventListener('DOMContentLoaded', launchtertiary);

if (window.shouldlaunchtertiary) {
  // if another react app has told us it is ready for tertiary nav injection:
  launchtertiary();
  window.shouldlaunchtertiary = false;
} else {
  // otherwise, provide the function to launch when ready
  window.launchtertiary = launchtertiary.bind(this);
}

// Inject the website footer
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', injectWebsiteFooter);
} else {
  injectWebsiteFooter();
}

// Inject the add item drawer
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', injectAddItemDrawer);
} else {
  injectAddItemDrawer();
}
